// eslint-disable-next-line import/no-extraneous-dependencies
import {useInitialUtmParams, useQueryParamsCallback} from '@aboutyou/router';
import {useCallback} from 'react';

export enum AdjustTracker {
  APP_DOWNLOAD_INCENTIVE_BAR = '17ncnccm',
  APP_DOWNLOAD_INCENTIVE_BADGE = '18s2vj6v',
  DESK_OSP_WEB_COUPON_BANNER = '16v5syw5',
  DESK_WEB_COUPON_BANNER = '16s4rufq',
  MWEB_OSP_WEB_COUPON_BANNER = '16zhrq5t',
  MWEB_WEB_COUPON_BANNER_BROWSE_PAGE = '16paz2hn',
  MWEB_WEB_COUPON_BANNER_CATEGORY_PAGE = '16v6j3uh',
  MWEB_WEB_COUPON_BANNER_OFF_CANVAS = '16hfeoej',
}

const adjustParamMap = {
  campaign: 'utm_medium',
  adgroup: 'utm_source',
  creative: 'utm_campaign',
} as const;

const BASE_ADJUST_IMPRESSION_URL = 'https://view.adjust.com/impression';

const cache: Partial<Record<AdjustTracker, boolean>> = {};

export const useTrackAdjustImpression = ({
  adjustTracker,
}: {
  adjustTracker: AdjustTracker;
}) => {
  const getQueryParams = useQueryParamsCallback();
  const utmParams = useInitialUtmParams();

  return useCallback(() => {
    if (cache[adjustTracker]) {
      return;
    }

    cache[adjustTracker] = true;

    const url = new URL(`${BASE_ADJUST_IMPRESSION_URL}/${adjustTracker}`);
    const urlParams = getQueryParams({includeUtmParams: true});

    // map utm params
    for (const [key, equivalentKey] of Object.entries(adjustParamMap)) {
      const value = utmParams.get(equivalentKey);
      if (value) {
        urlParams.append(key, value);
      }
    }

    // remove utm params
    for (const key of utmParams.keys()) {
      urlParams.delete(key);
    }

    url.search = urlParams.toString();

    return fetch(url.toString(), {mode: 'no-cors'});
  }, [adjustTracker, utmParams]);
};
